import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface AnimatedCounterProps {
  value: number;
  suffix?: string;
  duration?: number;
}
export function AnimatedCounter({
  value,
  suffix = '',
  duration = 2000
}: AnimatedCounterProps) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (!isInView) return;
    let startTime: number;
    let animationFrame: number;
    const updateCount = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      if (progress < duration) {
        const nextCount = Math.min(Math.floor(progress / duration * value), value);
        setCount(nextCount);
        animationFrame = requestAnimationFrame(updateCount);
      } else {
        setCount(value);
      }
    };
    animationFrame = requestAnimationFrame(updateCount);
    return () => cancelAnimationFrame(animationFrame);
  }, [value, duration, isInView]);
  // Format number with commas if it's large
  const formattedCount = count >= 1000 ? count.toLocaleString() : count;
  return <span ref={ref} data-id="element-36">
      {formattedCount}
      {suffix}
    </span>;
}